import { useState, useEffect } from "react";

const API = process.env.REACT_APP_API_URL;

export function useJ2PuzzleState({ code, playerId, puzzleType, initialState }) {
  const [state, setState] = useState(initialState);
  const [loaded, setLoaded] = useState(false);

  // Charger l'état au montage
  useEffect(() => {
    const loadState = async () => {
      try {
        const response = await fetch(
          `${API}/api/sessions/${code}/player2-puzzle-state/${puzzleType}`
        );
        const data = await response.json();

        if (data.state) {
          setState(data.state);
        }
        setLoaded(true);
      } catch (error) {
        console.error("Failed to load puzzle state:", error);
        setLoaded(true);
      }
    };

    loadState();
  }, [code, puzzleType]);

  // Sauvegarder l'état (debounced)
  useEffect(() => {
    if (!loaded) return; // Ne pas sauvegarder avant le chargement initial

    const saveState = async () => {
      try {
        await fetch(`${API}/api/sessions/${code}/player2-puzzle-state`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            playerId: Number(playerId),
            puzzleType,
            state,
          }),
        });
      } catch (error) {
        console.error("Failed to save puzzle state:", error);
      }
    };

    const timeout = setTimeout(saveState, 500); // Debounce 500ms
    return () => clearTimeout(timeout);
  }, [state, loaded, code, playerId, puzzleType]);

  return [state, setState, loaded];
}